'use client';
import React from 'react';
import { ConfigSelectorOption, ConfigSelectorTab } from './entities';
import { ConfigSelectorBox } from './ConfigSelectorBox';
import styled from '@benzinga/themetron';
import { ConfigSelectorModal } from './ConfigSelectorModal';

export interface ConfigSelectorProps {
  resourceName?: string;
  selectedConfig: ConfigSelectorOption | undefined;
  tabs: ConfigSelectorTab[];
  modalParentRef?: HTMLDivElement | null;
  onSelect: (id: string) => void;
  onRemove: (id: string) => void;
  onFavorite?: (id: string, favorite: boolean) => void;
  onNameEdit?: (id: string, newName: string) => void;
  onSave: (config: ConfigSelectorOption) => void;
  onNewSave: (name: string) => void;
  saveTooltip?: string;
  saveEnabled?: boolean;
}

export const ConfigSelector: React.FC<ConfigSelectorProps> = props => {
  const [state, setState] = React.useState<{
    modalOpen: boolean;
    inputText: string;
  }>({
    inputText: '',
    modalOpen: false,
  });

  const resourceName = React.useMemo(() => props.resourceName ?? 'config', [props.resourceName]);

  const onBoxClick = React.useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    setState(s => ({ ...s, modalOpen: true }));
  }, []);

  return (
    <ConfigSelectorWrapper>
      <ConfigSelectorBox
        onBoxClick={onBoxClick}
        onFavoriteClick={props.onFavorite}
        onSave={props.onSave}
        resourceName={resourceName}
        saveEnabled={props.saveEnabled}
        saveTooltip={props.saveTooltip}
        selectedConfig={props.selectedConfig}
      ></ConfigSelectorBox>
      <ConfigSelectorModal
        {...props}
        isOpen={state.modalOpen}
        onClose={() => setState(s => ({ ...s, modalOpen: false }))}
        onNameEdit={props.onNameEdit}
        resourceName={resourceName}
        selectedConfig={props.selectedConfig}
      />
    </ConfigSelectorWrapper>
  );
};

const ConfigSelectorWrapper = styled.div`
  flex-grow: 1;
  max-width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`;
